
import Vue from 'vue';
import { ROUTER } from '@/router/constants';
import { mapGetters, mapState } from 'vuex';
import TeamMetricsBtns from '@/views/Team/TeamDashboard/TeamMetricsBtns.vue';
import BackButton from '@/components/base/BackButton.vue';
import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs.vue';
import { TeamUserMixin } from '@/mixins/TeamUserMixin';

export default Vue.extend({
	name: 'TeamOverview',
	props: {
		currTeam: { type: Object, default: null },
		currTeamUserRole: { type: Object, default: null },
		currBalanceAccount: { type: Object, default: null },
		loadingBalanceAccount: { type: Boolean, default: false },
	},
	mixins: [
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'user',
		]),
		...mapGetters([
			'displayLabels',
		]),
		breadcrumbs () {
			return [
				{
					hoverColor: 'var(--primary-purple)',
					text: 'Company Dashboard',
					disabled: false,
					to: {
						name: ROUTER.COMPANY_DASHBOARD,
						query: this.$route.query,
					},
				},
				{
					hoverColor: 'var(--primary-blue)',
					text: this.currTeam?.name || `${this.displayLabels.team} Dashboard`,
					disabled: true,
					to: {
						name: ROUTER.TEAM_DASHBOARD,
						params: {
							teamId: this.$route.params.teamId,
						},
						query: this.$route.query,
					},
				},
			];
		},
	},
	methods: {
		goBack () {
			// Go through breadcrumbs in reverse order to find the back route
			for (let i = this.breadcrumbs.length - 1; i >= 0; i--) {
				const breadcrumb = this.breadcrumbs[i];
				if (breadcrumb.to && !breadcrumb.disabled) {
					this.routerPush(this.$route, this.$router, breadcrumb.to);
					return;
				}
			}
		},
	},
	components: {
		TeamMetricsBtns,
		BackButton,
		BaseBreadcrumbs,
	},
});
